import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import DEVICES from '../../common/styles/devices';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const CardContainer = styled.div`
  cursor: pointer;
  margin-bottom: 12px;
  border: 1px solid ${COLORS.borderGrey};
  padding: 11px 24px 11px 0px;
  border-radius: 2px;
  background-color: ${COLORS.white};
  display: grid;
  grid-template-columns: 5fr 15fr 2fr;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: ${FONT_FAMILY.hellix.regular};

  .image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    img {
      align-self: center;
      height: 50px;
      width: 50px;
    }
    .cardIconText {
      font-weight: 400;
      color: ${COLORS.textLightGrey};
      font-size: 14px;
      line-height: 18px;
      margin-top: 4px;
    }
  }

  .mid-section-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .heading {
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 18px;
      font-weight: 700;
      line-height: 26px;
    }
    .subHeading {
      text-align: left;
      line-height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: ${COLORS.textGrey};
      margin-top: 6px;
    }
    .extraInfo {
      line-height: 18px;
      font-size: 14px;
      font-weight: 400;
      color: ${COLORS.textLightGrey};
      margin-top: 6px;
    }
  }

  .rightIconContainer {
    text-align: center;
    display: flex;
    justify-content: flex-end;
  }

  @media ${DEVICES.mobileS} {
    padding: 11px 5px 11px 0px;
  }
`;
